import React, { ComponentPropsWithRef } from 'react'
import { useCommonCtx } from '../context/useCommonCtx'
import { useTranslation } from '../i18n/useTranslation'
import { MTypo } from '../components/MTypo/MTypo'
import type { TypographyVariant } from '../types/mui'
import { isMobilePortrait } from '../utils'

interface Props extends ComponentPropsWithRef<'div'> {
    titleV: TypographyVariant
    bodyV: TypographyVariant
}
/**
 * @param p
 * @returns
 */
export const HowTo360 = (p: Props) => {
    const commons = useCommonCtx()
    const t = useTranslation(commons)

    const {
        state: { params: {brandParams} },
    } = commons

    return (
        <div className="flex flex-1 flex-col justify-evenly items-center">
            {brandParams.companyLogoUrl && (
                <img
                    src={brandParams.companyLogoUrl}
                    className="object-contain"
                    alt="logo"
                    height={75}
                    width={75}
                />
            )}
            <MTypo variant={'body1'} className="text-center">
                {t('howto_360_title')}
            </MTypo>
            <div className={'border-0 border-black border-solid'}>
                <img
                    className={`w-full pointer-events-none`}
                    src={
                        isMobilePortrait()
                            ? brandParams.brandImageUrlMobile
                            : brandParams.brandImageUrl
                    }
                />
            </div>
            <MTypo variant={'body1'} className="text-center italic">
                {t('howto_360_body')}
            </MTypo>
        </div>
    )
}
